import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import "./content.css";

const RefundPolicy = () => {
  return (
    <div className="terms content_page">
      <div className="terms-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 pt-5">
              <div className="terms-info-wraps">
                {/* <Breadcrumb name={"Refund and Cancellation Policy"} pageName={"Refund and Cancellation Policy"} /> */}
                <div className="privacy-area">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="privacy-info-wraps">
                          <h4>Refund and Cancellation Policy</h4>
                          <p>
                          This Refund Policy (&quot;Policy&quot;) applies exclusively to subscriptions purchased for the
Classhila Centres goal/category (&quot;Subscription&quot;) by paying a subscription fee
(&quot;Subscription Fee&quot;) through www.classhila.com or the Classhila Mobile Application
(&quot;Platform&quot;), provided by Classhila Education Private Limited (&quot;Company&quot;).  </p>
                          <p>The terms and conditions outlined in this Policy govern the process for refunding the
Subscription Fee paid by a user or learner (&quot;Subscriber&quot;) on the Platform for the
Subscription.</p>
<p>Please note that this Policy is not applicable to any other subscriptions, products, or
features offered on the Platform. It is strictly limited to the Subscription for the specified
goal/category described above.</p>
<p>This Policy must be read in conjunction with the Terms and Conditions, Privacy Policy,
and any other policies available on the Platform (“Platform Terms”). Any terms not
explicitly defined in this Policy shall have the meaning assigned to them in the Platform
Terms.</p>
<p>If the Subscription fails to meet a Subscriber’s expectations or requirements due to any
circumstances or limitations on the Company’s part, the Subscriber may submit a refund
request (“Refund Request”) by contacting the Company. The Refund Request must be
submitted within the applicable “Refund Window(s)” outlined below. Upon acceptance of
the Refund Request by the Company, the transaction will be canceled, and the
Subscription Fee will be refunded to the Subscriber, subject to applicable deductions as
specified in this Policy.</p>
<p>For Subscribers who have purchased Subscriptions for batches listed on the Platform
and submit a Refund Request within the designated Refund Window(s), the Company
will process the refund as follows:</p>
                          <ul>
                            <li>85% of the Subscription Fee paid if the Refund Request is raised within 7 days from
                            commencement of the batch.</li>
                            <li>70% of the Subscription Fee paid if the Refund Request is raised within 10 days from
                            commencement of the batch</li>
                            <li>0% of the Subscription Fee paid if the Refund Request is raised after 10 days from
                            commencement of the batch.</li>
                          </ul>

                          <p>Refunds will not be issued for payments made solely for registration purposes. Refund
requests will only be considered for payments made directly toward a Subscription,
subject to the terms outlined in this Policy.</p>
<p>The Company will not provide refunds for any reason, including but not limited to lack of
usage or dissatisfaction with a batch or educators, if the Refund Request is received
after the Refund Window has expired. Requests received after the Refund Window may
be considered at the Company’s sole discretion, and any refund granted in such cases,
whether full or partial, will be entirely at the Company’s judgment.</p>
<p>To process a refund, the Company may contact the Subscriber to verify details within
seven (7) business days from the date the Refund Request is received. Refund
Requests must be initiated exclusively from the registered email ID and phone number
of the Subscriber. For clarity, a business day is any day other than a Saturday, Sunday,
public holiday, or bank holiday in India or in the state where the Company’s office(s) are
located.</p>
<p>Once a Refund Request has been initiated, it cannot be withdrawn, even if the
Subscriber decides to continue with the Subscription.</p>
<p>Refunds will be issued to the same payment source used for the Subscription purchase.
If there are any issues or errors in processing the refund to the original payment source,
the Subscriber may be required to provide details of an alternate bank account along
with requisite verification documents, such as a canceled cheque for the relevant
account.</p>
<p>If the Subscriber fails to provide the requested details of an alternate bank account
within fourteen (14) business days of the Company&#39;s written request, the Company will
not be obligated to process the refund of the Subscription Fee.</p>
<p>While the Company shall refund the Subscription Fee there shall be deductions
Refunds will be processed net of applicable charges, including interest and taxes. While
the Company strives to provide an exceptional learning experience, it reserves the right
to revoke or cancel a refund if any fraudulent activity is identified, including but not
limited to violations of the Platform Terms or applicable laws by the Subscriber
requesting the refund. In such cases, no further attempts will be made to process the
refund.</p>
<p>All approved refunds will be processed via online transfer in Indian Rupees only, and
the refund will be credited to the original payment source. Refunds will be processed
within a reasonable period of 28 days from the date the Company provides written
confirmation approving the cancellation. Under no circumstances will the refund amount
exceed the amount originally paid for the purchase. If the purchase was made using a
credit or financing facility, refunds will be coordinated with the respective lender or
financing partner.</p>
<p>If the original payment instrument or account is inactive or does not support refunds, the
Subscriber must provide alternative bank account details belonging to them for
processing the refund. The Company shall not be responsible for refunds credited to an
incorrect account due to inaccurate details provided by the Subscriber. In such cases,

the Subscriber must furnish a declaration, in the format and manner required by the
Company, authorizing the transfer of the refund to an alternate account.</p>
<p>The Company reserves the right to modify or replace this Policy at any time, as deemed
necessary, without prior notice.</p>
<p>By proceeding, you confirm and acknowledge that you have read, understood, and
accepted the terms outlined in this Policy. Additionally, you agree not to dispute the
refund terms specified herein or raise any claims beyond the scope of this Policy.</p>

                          <p>
                          To cancel your subscription, you must submit a cancellation request by emailing <a href="mailto:support@classhila.com">support@classhila.com</a> and including your order details and a copy of the invoice.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
